<template lang="pug">
.row.news-list.mb-4
  .col-md-9.col-sm-8
    .text.bg-white.py-3.px-4
      span.text-black-50.small {{ formatDate(news.created) }}
      a
        h4 {{ news.title }}
        p.mb-0(v-html="news.content")
      span.text-black-50.small(style="margin-right: 12px")
        font-awesome-icon.mr-1(:icon="['fas', 'eye']") 
        | {{ news.view_count }}
      span.text-black-50.small
        font-awesome-icon.mr-1(:icon="['fas', 'share-alt']") 
        | {{ news.share_count }}
  .col-md-3.col-sm-4
    .photo(
      v-if="news.photo",
      :style="{ backgroundImage: 'url(' + news.photo.image + ')' }"
    )
</template>

<script>
import moment from "moment";

export default {
  name: "newsItem",
  props: { news: Object },
  methods: {
    formatDate(date) {
      return moment(date).format("MMM,DD,YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/news/news_item";
</style>
